import React, { useState, useEffect } from 'react';
import TabQRCode from '../tabs/TabQRCode';
import { apiGet } from '../utils/api-client';

/**
 * TabQRCodeContainer
 *
 * Fetch /api/dashboard pour récupérer :
 *  - restaurant.nom  → restoName
 *  - restaurant.slug → reviewLink = https://www.getrevyo.com/r/{slug}
 *  - stats.scans_total / satisfaits / feedbacks_negatifs
 */
export default function TabQRCodeContainer() {
  const [restoName, setRestoName]     = useState('Mon restaurant');
  const [reviewLink, setReviewLink]   = useState('https://www.getrevyo.com/r/demo');
  const [stats, setStats]             = useState({
    scans: 0,
    avisGeneres: 0,
    tauxConversion: 0,
    feedbacks: 0,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await apiGet('/api/dashboard/');
        if (cancelled) return;
        const r = data?.restaurant || {};
        const s = data?.stats      || {};

        setRestoName(r.nom || 'Mon restaurant');

        if (r.slug) {
          setReviewLink(`https://www.getrevyo.com/r/${r.slug}`);
        }

        const scans       = s.scans_total ?? 0;
        const satisfaits  = s.satisfaits ?? 0;
        const feedbacks   = s.feedbacks_negatifs ?? 0;
        const avisGeneres = data?.avis_generes_revyo ?? satisfaits;
        const conversion  = scans > 0 ? (avisGeneres / scans) * 100 : 0;

        setStats({
          scans,
          avisGeneres,
          tauxConversion: conversion,
          feedbacks,
        });
      } catch (e) {
        console.error('[TabQRCode] load error:', e);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <TabQRCode
      restoName={restoName}
      reviewLink={reviewLink}
      stats={stats}
    />
  );
}
